import React from 'react'
const Web_Development = () => {
  return (
    <>
      <section className="web_development">
        <div className="container">
          <div className="content">
            <h2>WEBSITE</h2>
            <h1>DEVELOPMENT</h1>
          </div>
        </div>
      </section>
      <section className="web_development1">
        <div className="container py-5">
          <div className="row d-flex align-items-center">
            <div className="col-lg-4">
              <img src="img/web-dev/website.jpeg" className='img-fluid' alt="Website-IMG" />
            </div>
            <div className="col-lg-8">
              <div className="content">
                <h2>Interactive Web Development Solutions</h2>
                <p style={{ textAlign: "justify" }}>At Muhammad Rizwan, We Focus On Web Designs That Are Functionality Fast And Seamlessly Interactive For The Critical Audience Of Today And Tomorrow. Our Web Development Service Focuses On Building Responsive Interfaces To Tame The Increasing Bounce Rate Of Users. Our Developers Help Businesses Seize The Digital Footprint With Optimized User-interaction And User-engagement For The Critical Audience Of Today And Tomorrow. Our Web Development Service Focuses On Building Responsive Interfaces To Tame The Increasing Bounce Rate Of Users. Our Developers Help Businesses Seize The Digital Footprint With Optimized User-interaction And User-engagement.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="web_development2">
        <div className="container">
          <div className="content">
            <h6>SERVICES</h6>
            <h1>SEIZE THE GLOBAL REACH WITH <span style={{ color: "#30ADA7", fontFamily: "heading" }}>MUHAMMAD RIZWAN </span></h1>
            <p>At Muhammad Rizwan, the focus is not only on website designing, but also on scaling and maintaining websites for businesses to benefit from continued user-interaction. We aspire to bring businesses in the digital landscape for more leads and conversions.</p>
          </div>
        </div>
      </section>
      <section className="web_development3">
        <div className="container">
          <div className="row py-5">
            <div className="col-lg-4 col-md-6 my-2 d-flex align-items-stretch">
              <div className="card p-3 text-center">
                <center><img src="img/cms.png" width={50} alt="CMS" /></center>
                <h4 className='text-white py-1'>CMS DEVELOPMENT</h4>
                <p style={{ textAlign: "justify" }}>Our PHP developers are robust and productive in their development approach and allow businesses the leverage to maintain their digital presence in a single interface. With an easy back-end and a manageable interface, multiple niches can benefit from our CMS development services.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 my-2 d-flex align-items-stretch">
              <div className="card p-3 text-center">
                <center><img src="img/ecommerce.png" width={50} alt="commerce" /></center>
                <h4 className='text-white py-1'>E-COMMERCE DEVELOPMENT</h4>
                <p style={{ textAlign: "justify" }}>E-Commerce development with Rizwan helps scaling businesses with a functional site strategy, layout, and improved buyer journey. We offer custom ecommerce development services with critical focus on advanced platform selection, database integration, and overall ecommerce experience.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 my-2 d-flex align-items-stretch">
              <div className="card p-3 text-center">
                <center><img src="img/magento.png" width={50} alt="magento" /></center>
                <h4 className='text-white py-1'>MAGENTO DEVELOPMENT</h4>
                <p style={{ textAlign: "justify" }}>Muhammad Rizwan provides website maintenance services in USA to help businesses optimize the performance of their website including regular checks, database backups, browser compatibility tests, speed improvisation, HTML error fixing, and overall software upgradation.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
export default Web_Development